import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import logo from '/img/procesta.png'; // make sure the logo file is placed correctly

const Footer = () => {
 
  return (
    <footer className="relative bg-gradient-to-t from-blue-700 to-blue-600 text-white mt-12">
      {/* decorative svg wave */}
      <div className="absolute -top-8 left-0 w-full overflow-hidden leading-[0]">
        <svg
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
          className="block w-full h-20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0,0 C150,100 350,100 600,50 C850,0 1050,100 1200,50 L1200,120 L0,120 Z"
            fill="#0ea5e9"
            fillOpacity="0.15"
          />
          <path
            d="M0,10 C150,110 350,110 600,60 C850,10 1050,110 1200,60 L1200,120 L0,120 Z"
            fill="#0369a1"
            fillOpacity="0.06"
          />
        </svg>
      </div>

      <div className="container mx-auto px-6 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About / Logo */}
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <img src={logo} alt="Procesta Logo" className="h-12 w-12" />
              <div>
                <h3 className="font-bold text-lg">Procesta Physiotherapy Hospital</h3>
                <p className="text-sm text-blue-100">Assurance of Better Treatment & Quality Service</p>
              </div>
            </div>
            <p className="text-sm text-blue-100 max-w-sm">
              We specialize in evidence-based physiotherapy, pain management and rehabilitation to help you
              move, feel, and live better.
            </p>

            <div className="flex gap-3 mt-2">
              <a href="#" aria-label="facebook" className="hover:opacity-80">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22 12.07C22 6.48 17.52 2 11.919 2 6.33 2 1.85 6.48 1.85 12.07c0 4.99 3.657 9.128 8.438 9.877v-6.99H8.078V12.07h2.21V9.797c0-2.188 1.313-3.397 3.325-3.397.963 0 1.972.173 1.972.173v2.171h-1.106c-1.09 0-1.429.678-1.429 1.374V12.07h2.435l-.39 2.885h-2.045v6.99C18.343 21.198 22 17.062 22 12.07z" />
                </svg>
              </a>
              <a href="#" aria-label="twitter" className="hover:opacity-80">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.46 6c-.77.35-1.6.58-2.46.69a4.26 4.26 0 001.88-2.35 8.55 8.55 0 01-2.7 1.03 4.25 4.25 0 00-7.24 3.87A12.07 12.07 0 013 4.79a4.25 4.25 0 001.32 5.67c-.66-.02-1.28-.2-1.82-.5v.05c0 2.04 1.45 3.74 3.38 4.12-.56.15-1.15.17-1.74.06.49 1.53 1.92 2.65 3.61 2.68A8.53 8.53 0 012 19.54a12.05 12.05 0 006.52 1.91c7.83 0 12.11-6.49 12.11-12.11v-.55A8.62 8.62 0 0022.46 6z" />
                </svg>
              </a>
              <a href="#" aria-label="instagram" className="hover:opacity-80">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 6.4A4.6 4.6 0 1016.6 13 4.6 4.6 0 0012 8.4zm6.5-2.9a1.1 1.1 0 11-1.1-1.1 1.1 1.1 0 011.1 1.1z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-3">Quick Links</h4>
            <ul className="space-y-2 text-blue-100">
              <li className="hover:text-white cursor-pointer">Home</li>
              <li className="hover:text-white cursor-pointer">Treatments</li>
              <li className="hover:text-white cursor-pointer">About</li>
              <li className="hover:text-white cursor-pointer">Contact</li>
              <li className="hover:text-white cursor-pointer">Make an Appointment</li>
            </ul>
          </div>

          {/* Contact / Appointment */}
          <div>
            <h4 className="font-semibold mb-3">Contact</h4>
            <p className="text-sm text-blue-100">Sugandha R/A,Mirzarpool, Panchlaish, Chittagong, Bangladesh</p>
            <p className="text-sm text-blue-100">Phone: +8801842-976655</p>
            <p className="text-sm text-blue-100">Email: info@procestaph.com, procestaph@gmail.com</p>

            <div className="mt-4">
              <a
                href="/appointment"
                className="inline-block px-4 py-2 bg-white text-blue-600 rounded-lg font-semibold shadow hover:opacity-95"
              >
                Make an Appointment
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 border-t border-blue-500 pt-6 text-center text-sm text-blue-200">
          © {new Date().getFullYear()} Procesta Physiotherapy Hospital. All rights reserved.
        </div>
      </div>
    </footer>
  );
};
export default Footer;

